import { getAsyncResourceDataOptional } from 'fabscale-app/utilities/utils/get-async-resource-value';
import { AsyncResource } from './base-async-resource';

export default function resourceGetDataHelper<DataType>(
  asyncResource: AsyncResource<DataType>,
  fallback?: any
) {
  return getAsyncResourceDataOptional(asyncResource, fallback);
}
